import { render, staticRenderFns } from "./CreateSpecification.vue?vue&type=template&id=74380166&scoped=true&"
import script from "./CreateSpecification.vue?vue&type=script&lang=js&"
export * from "./CreateSpecification.vue?vue&type=script&lang=js&"
import style0 from "./CreateSpecification.vue?vue&type=style&index=0&id=74380166&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74380166",
  null
  
)

export default component.exports